module.exports = __webpack_public_path__ + "img/tooltip.755fdf00.svg";